<h2 mat-dialog-title i18n>Profileinstellungen bearbeiten</h2>
<mat-dialog-content class="settings-dialog-content">
  <form [formGroup]="settingsForm" class="settings-form">
    <div class="setting-item">
      <div class="setting-header">
        <span i18n>Anzeigesprache</span>
      </div>
      <mat-form-field>
        <mat-label i18n>Sprache</mat-label>
        <mat-select formControlName="displayLanguage" [disabled]="loading$()">
          @for (language of displayLanguageOptions; track language.code) {
            <mat-option [value]="language.code">{{
              language.label
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="warn">
    <mat-icon>close</mat-icon>
    <span i18n>Abbrechen</span>
  </button>
  <button
    color="primary"
    mat-raised-button
    (click)="onSave()"
    [disabled]="loading$() || settingsForm.invalid || settingsForm.pristine"
  >
    <mat-icon>save</mat-icon>
    <span i18n>Speichern</span>
  </button>
</mat-dialog-actions>
